import { render } from "./SlideShow.vue?vue&type=template&id=ed86a0ae&scoped=true"
import script from "./SlideShow.vue?vue&type=script&lang=js"
export * from "./SlideShow.vue?vue&type=script&lang=js"

import "./SlideShow.vue?vue&type=style&index=0&id=ed86a0ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed86a0ae"]])

export default __exports__